import { Box, Button, FormControl, Grid, IconButton, InputLabel, MenuItem, OutlinedInput, Paper, Select, Tab, Tabs, TextField } from "@mui/material";
import DefaultDrawer from "../../components/default-drawer";
import { ACTION_TYPES, useConsultaRemessaDispatch, useConsultaRemessaState } from "./context/consulta-remessa-context";
import moment from "moment";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { ISubmissionPublicationFileResponse } from "../../../model/publication-shipment/response/submissin-publication-file-response";
import { useEffect, useState } from "react";
import { IPublishingVehicleResponse } from "../../../model/publication-shipment/response/publising-vehicle-response";
import DownloadIcon from '@mui/icons-material/Download';
import { useConsultaRemessaController } from "./context/consulta-remessa-controller";
import { IUpdatePublicationShipmentRequest } from "../../../model/publication-shipment/request/update-publication-shipment-request";
import { DefaultDialogProps } from "../../components/default-dialog";
import SaveIcon from '@mui/icons-material/Save';
import React from "react";
import { useBaseLayoutController } from "../../base-layout/context/base-layout-controller";
import { useGlobalState } from "../../global/context/global-context";
import { useNavigate } from "react-router-dom";
import DrawIcon from '@mui/icons-material/Draw';
export const DetalheRemessa = () => {
    const { showDialog } = useBaseLayoutController();
    const { detailPublicationShipmentResponse, listSatusPublicatioShipment, updatePublicationShipmentRequest } = useConsultaRemessaState();
    const { downloadFile, downloadFiles, handleOnChangeUpdate, update } = useConsultaRemessaController();
    const consultRmessaDispatch = useConsultaRemessaDispatch();
    const [tabIndex, setTabIndex] = useState(0);
    const { applicationData } = useGlobalState();
    const navigate = useNavigate();

    useEffect(() => {
        consultRmessaDispatch({
            type: ACTION_TYPES.setUpdatePublicationShipmentRequest,
            payload: { id: detailPublicationShipmentResponse?.id, statusId: detailPublicationShipmentResponse?.statusId, diagramerObservation: detailPublicationShipmentResponse?.diagramerObservation } as IUpdatePublicationShipmentRequest,
        });
    }, [detailPublicationShipmentResponse]);

    const onClose = () => {
        consultRmessaDispatch({
            type: ACTION_TYPES.setDetailPublicationShipmentResponse,
            payload: null,
        });
    }
    const handleTabChange = (event: any, newTabIndex: number) => {
        setTabIndex(newTabIndex);
    };
    const colunsVehicles: GridColDef<IPublishingVehicleResponse>[] = [
        // { field: 'id', headerName: 'Nº', hide: true, width: 90,  sortable: false },
        {
            field: 'name',
            headerName: 'Nome',
            flex: 6, sortable: false
        }]
    const colunsFiles: GridColDef<ISubmissionPublicationFileResponse>[] = [
        // { field: 'id', headerName: 'Nº', width: 90, hideable: true, sortable: false },
        // { field: 'idRemessa', headerName: 'Nº', width: 90, hideable: true, sortable: false },
        {
            field: 'name',
            headerName: 'Arquivo',
            flex: 6, sortable: false
        },
        {
            field: "action",
            headerName: "",
            sortable: false,
            flex: 1,
            align: "center",
            headerAlign: "center",
            renderCell: (params) => {
                return (
                    <IconButton color="primary" aria-label="Baixar Arquivo" component="label" onClick={async () => {
                        var result = await downloadFile(params.row.idPublicationSubmission, params.row.id);
                        result.download();
                    }}>
                        <DownloadIcon />
                    </IconButton>);

            }
        }
    ];

    const actions = () => {
        return (
            <React.Fragment>
                 {applicationData?.moduleId === 2 && detailPublicationShipmentResponse?.statusId !== 4 && detailPublicationShipmentResponse?.statusId !== 5 && (
                    <Button variant="contained" onClick={() => {
                        showDialog({
                            open: true,
                            message: "Deseja realmente diaggramar essa remessa de publicação?",
                            onYesClick: () => {
                                navigate(`/diagramar-diario-oficial/${detailPublicationShipmentResponse?.id}`)
                            }
                        } as DefaultDialogProps);
                    }} endIcon={ <DrawIcon />}>Diagramar</Button>
                    
                )
                }
                      {applicationData?.moduleId === 2 && detailPublicationShipmentResponse?.statusId !== 4 && detailPublicationShipmentResponse?.statusId !== 5 && (
                    <Button variant="contained" onClick={() => {
                        showDialog({
                            open: true,
                            message: "Deseja realmente salvar essa remessa de publicação?",
                            onYesClick: () => {
                                (async () => {
                                    await update();
                                    consultRmessaDispatch({
                                        type: ACTION_TYPES.setDetailPublicationShipmentResponse,
                                        payload: null,
                                    });
                                })();
                            }
                        } as DefaultDialogProps);
                    }} endIcon={<SaveIcon />}>Salvar</Button>
                    
                )
                }
                
               

            </React.Fragment >
        )
    }

    return (
        <DefaultDrawer isOpen={detailPublicationShipmentResponse !== null && detailPublicationShipmentResponse !== undefined} title={`Detalhes da Remessa de Publicação Nº ${detailPublicationShipmentResponse?.id}`} onClose={onClose}
            actions={() => {
                return actions();
            }}>
            <Grid container lg={12}
                sm={12}
                xl={12} spacing={2}>
                <Grid item lg={4}
                    sm={4}
                    xl={4}>
                    <InputLabel>Nº Remessa</InputLabel>
                    <OutlinedInput
                        size="small"
                        disabled
                        fullWidth
                        value={detailPublicationShipmentResponse?.id}
                    />
                </Grid>
                <Grid item lg={4}
                    sm={4}
                    xl={4}>
                    <InputLabel>Status</InputLabel>
                    <Select name="select-status" fullWidth
                        size="small"
                        disabled={applicationData?.moduleId === 2 && detailPublicationShipmentResponse?.statusId !== 4 && detailPublicationShipmentResponse?.statusId !== 5 ? false : true}
                        onChange={handleOnChangeUpdate}
                        value={updatePublicationShipmentRequest != null ? updatePublicationShipmentRequest.statusId ?? "" : null}
                    >
                        {listSatusPublicatioShipment.map((element) => {
                            return (
                                <MenuItem value={element.id} key={element.id}>{element.description}</MenuItem>
                            );
                        })}
                    </Select>
                </Grid>
                <Grid item lg={4}
                    sm={4}
                    xl={4}>
                    <InputLabel>Tipo</InputLabel>
                    <OutlinedInput

                        size="small"
                        fullWidth
                        disabled
                        value={detailPublicationShipmentResponse?.typeDescription}></OutlinedInput>


                </Grid>
                <Grid item lg={7}
                    sm={7}
                    xl={7}>
                    <InputLabel>Titulo</InputLabel>
                    <OutlinedInput
                        fullWidth
                        size="small"
                        disabled
                        value={detailPublicationShipmentResponse?.title}
                    />
                </Grid>
                <Grid item lg={3}
                    sm={3}
                    xl={3}>
                    <InputLabel>Enviada em</InputLabel>
                    <OutlinedInput
                        size="small"
                        fullWidth
                        disabled
                        value={moment(detailPublicationShipmentResponse?.sendDate).format("DD/MM/yyyy HH:mm:ss")}
                    />
                </Grid>
                <Grid item lg={2}
                    sm={2}
                    xl={2}>
                    <InputLabel>Publicar em</InputLabel>
                    <OutlinedInput
                        size="small"
                        fullWidth
                        disabled
                        value={moment(detailPublicationShipmentResponse?.publishDate).format("DD/MM/yyyy")}
                    />
                </Grid>

                <Grid item lg={12}
                    sm={12}
                    xl={12}>
                    <InputLabel>Enviada por</InputLabel>
                    <OutlinedInput
                        fullWidth
                        size="small"
                        disabled
                        value={detailPublicationShipmentResponse?.userSenderName}
                    />
                </Grid>
                <Grid item lg={12}
                    sm={12}
                    xl={12}>
                    <InputLabel>Entidade</InputLabel>
                    <OutlinedInput
                        size="small"
                        fullWidth
                        disabled
                        value={detailPublicationShipmentResponse?.personEntityName}
                    />
                </Grid>

                <Grid item lg={12}
                    sm={12}
                    xl={12}>
                    <InputLabel>Descrição</InputLabel>
                    <TextField
                        size="small"
                        multiline
                        fullWidth
                        rows={4}
                        disabled
                        value={detailPublicationShipmentResponse?.description}
                    />

                </Grid>
                <Grid item lg={12}
                    sm={12}
                    xl={12}>
                    <InputLabel>Observação</InputLabel>
                    <TextField
                        size="small"
                        multiline
                        fullWidth
                        rows={4}
                        disabled
                        value={detailPublicationShipmentResponse?.observation}
                    />

                </Grid>
                <Grid item lg={12}
                    sm={12}
                    xl={12}>
                    <Box>
                        <Box>
                            <Tabs value={tabIndex} onChange={handleTabChange}>
                                <Tab label="Arquivos Enviados" />
                                <Tab label="Veículos de Publicação" />
                                <Tab label="Observação/Pendências" />
                            </Tabs>
                        </Box>
                        <Box sx={{ padding: 2 }}>
                            {tabIndex === 0 && (
                                <Box>
                                    <Grid container lg={12}
                                        sm={12}
                                        xl={12}>
                                        <Grid item lg={12}
                                            sm={12}
                                            xl={12}>
                                            <DataGrid
                                                columns={colunsFiles}
                                                sx={{ height: '230px' }}
                                                rows={detailPublicationShipmentResponse?.files}
                                                pagination={true}
                                                autoPageSize={false}
                                                localeText={{
                                                    noRowsLabel: "Não foi encontrado resultados",
                                                    MuiTablePagination: {
                                                        labelDisplayedRows: () =>
                                                            `Página 1 de 1`,
                                                    }
                                                }}
                                                disableRowSelectionOnClick={true}
                                            />
                                        </Grid>
                                        <Grid item lg={12}
                                            sm={12}
                                            xl={12} sx={{
                                                mt: 1,
                                                display: 'flex',
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "flex-end"

                                            }}>
                                            <Button variant="contained" onClick={async () => {
                                                if (detailPublicationShipmentResponse !== undefined && detailPublicationShipmentResponse.id !== undefined) {
                                                    var result = await downloadFiles(detailPublicationShipmentResponse.id);
                                                    result.download();
                                                }
                                            }} endIcon={<DownloadIcon />}>Baixar Todos</Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            )}
                            {tabIndex === 1 && (
                                <Box>
                                    <DataGrid
                                        columns={colunsVehicles}
                                        disableRowSelectionOnClick={true}
                                        sx={{ height: '250px' }}
                                        rows={detailPublicationShipmentResponse?.publishingVehicles}
                                        localeText={{
                                            noRowsLabel: "Não foi encontrado resultados",
                                            MuiTablePagination: {
                                                labelDisplayedRows: () =>
                                                    `Página 1 de 1`,
                                            }
                                        }}

                                        autoPageSize={false}
                                    // rowsPerPageOptions={[]}

                                    />
                                </Box>
                            )}
                            {tabIndex === 2 && (
                                <Box>
                                    <FormControl fullWidth>
                                        <TextField
                                            multiline
                                            name='input-diagramerObservation'
                                            rows={6}
                                            onChange={handleOnChangeUpdate}
                                            disabled={applicationData?.moduleId === 2  && detailPublicationShipmentResponse?.statusId !== 4 && detailPublicationShipmentResponse?.statusId !== 5 ? false : true}
                                            value={updatePublicationShipmentRequest?.diagramerObservation !== undefined ? updatePublicationShipmentRequest?.diagramerObservation : ""}
                                        />
                                    </FormControl>
                                </Box>
                            )}
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </DefaultDrawer>
    );
}